import React from "react";

function NavTop() {
  return (
    <div className="nav-top pt-30 pb-30">
      <div className="container">
        <div className="row">
          <div className="col-md-4 valign">
            <a href="#0" className="logo icon-img-60">
              {/* <img src="/assets/imgs/logo-light.png" alt="" /> */}
              <h4>NH_</h4>
            </a>
          </div>
          <div className="col-md-4 valign">
            <div className="social text-center full-width">
              <a
                href="mailto:hingwe90@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-envelope"></i>
              </a>
              <a
                href="tel:+917276389688"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-phone"></i>
              </a>
              <a
                href="https://github.com/nikhilhingwe"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/nikhil-h-780b681b8/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          <div className="col-md-4 valign">
            <div className="full-width info">
              <div className="d-flex justify-content-end">
                <a href="mailto:hingwe90@gmail.com">
                  <span className="sub-title fz-12">hingwe90@gmail.com</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="nav-butn">
          <span className="pe-7s-menu"></span>
        </div>
      </div>
    </div>
  );
}

export default NavTop;
